var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcumb-container"},[(_vm.name != null)?_c('img',{staticStyle:{"width":"24px"},attrs:{"src":require("../assets/icons/back.png")},on:{"click":_vm.back}}):_vm._e(),(_vm.name != null)?_c('h4',{staticClass:"bold",on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.name))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }